export default __webpack_public_path__ + "static/font-f5ec019f552586153114d651d50d760a.woff2";